import {
  MdBookmark,
  MdDocumentScanner,
  MdOutlineImageNotSupported,
} from "react-icons/md";
import { toTitleCase } from "../../util/toTitleCase";
import { useNavigate } from "react-router-dom";
import { isoDateToString } from "../../util/format-date";
import { FaCar, FaFileSignature } from "react-icons/fa";
import { IoMdDocument } from "react-icons/io";

export default function VehicleCard({ vehicle }) {
  const navigate = useNavigate();

  const classNames = () => {
    let classes = "grid text-sm pill lg:grid-cols-7";
    if (vehicle.onboarded) classes += " border-green-600";
    return classes;
  };

  return (
    <div
      data-tour="vehicle-card"
      onClick={() => navigate("/vehicles/info?vin=" + vehicle.vin)}
      className={classNames()}
    >
      {vehicle.vehicle?.cornerImage ? (
        <img src={vehicle.vehicle?.cornerImage} className="w-20" />
      ) : (
        <MdOutlineImageNotSupported className="w-10 h-10 ml-4 text-stone-400" />
      )}
      <div className="grid lg:col-span-2" data-tour="vehicle-name">
        <p className="font-semibold text-stone-200">
          {vehicle.year} {vehicle.make} {vehicle.model}
        </p>
        <p className="text-stone-400 ">{vehicle.vehicle?.trim}</p>
      </div>
      <div className="grid" data-tour="vehicle-vin">
        <p className="font-semibold text-stone-200">{vehicle.vin}</p>
        <p className="text-stone-400 ">
          {vehicle.license} {vehicle.licenseState}
        </p>
      </div>
      <div className="grid" data-tour="vehicle-ins">
        <p className="text-stone-200">{vehicle.institution}</p>
        <p className="text-stone-400">
          {isoDateToString(vehicle.dueDate) || "Unknown"}
        </p>
      </div>
      <p className="font-semibold text-stone-200" data-tour="vehicle-monthly">
        ${vehicle.monthlyPayment || "-"}
      </p>
      <div className="grid grid-cols-5 gap-4">
        <IoMdDocument
          className={`text-xl ${
            vehicle.loanDocument ? "text-green-600" : "text-red-600"
          }`}
          title="Loan Document"
          data-tour="vehicle-loan"
        />
        <MdDocumentScanner
          className={`text-xl ${
            vehicle.registeration ? "text-green-600" : "text-red-600"
          }`}
          title="Registration Document"
          data-tour="vehicle-reg"
        />
        <FaFileSignature
          className={`text-xl ${
            vehicle.agreement ? "text-green-600" : "text-red-600"
          }`}
          title="Vehicle Agreement"
          data-tour="vehicle-agreement"
        />
        <FaCar
          className={`text-xl ${
            vehicle.activeBookingId ? "text-green-600" : "text-red-600"
          }`}
          title="With Customer"
          data-tour="vehicle-booking"
        />
      </div>
    </div>
  );
}
